import React, { useEffect, useState } from 'react'
import { GET_EXTRA_FEEDS_API } from '../../../../actions/api';
import HttpClient from '../../../../actions/http-client';
import WallFeed from './Components/WallFeed'
import { baseUrl, getInitialRoute, TOAST_ERROR } from '../../../../utils';
import { shallowEqual, useSelector } from 'react-redux'; 


const getWidgetPlans = (id,plans) => {
    return plans.reduce((acc, curr) => {
        if(curr.id===id){
            acc = curr;
        }
        return acc;
    }, [])
}

function WallLimitExceed() {
    const [feeds, setFeeds] = useState([]);
    const [isFreePlan,setFreePlan] = useState(0);
    const [show,setShow] = useState(false);
    const [loading,setLoading] = useState(false);
    const [isFreePlanMsg,setFreePlanMsg] = useState('');
    const { plans } = useSelector(state => state.planDetails, shallowEqual);
    const activePlan =  Object.keys(plans).length > 0 ? getWidgetPlans(getInitialRoute() != 'widget'?4:6,plans).activePlan:'';

    useEffect(() => {
        getFeeds();
    }, [])


    const getFeeds = () => {
        setLoading(true);
        new HttpClient().post(GET_EXTRA_FEEDS_API,{type:getInitialRoute() != 'widget'?4:6}).then((response) => {
            if (response.data && Object.keys(response.data).length > 0) {
                const { responseData } = response.data;
                if (responseData && Object.keys(responseData).length > 0) {
                    const { wallList,isFreePlan,isFreePlanMessage } = responseData;
                    if (wallList.length > 0) {
                        setFeeds(wallList);
                    }
                    setLoading(false);
                    setShow(true);
                    setFreePlan(isFreePlan);
                    setFreePlanMsg(isFreePlanMessage);
                }
            }
        }).catch((ex) => {
            const { data } = ex.response;
            const errorMsg = data ? data.message:'';
            setLoading(false);
            TOAST_ERROR(errorMsg);
        });
    }

    const deleteWall = (wallId) => {
        const updateFeeds = feeds.filter(feed => feed.wallId != wallId);
        setFeeds(updateFeeds);
    }

    const deleteFeedFromWall = (wallId, feedIdList) => {
        const toDeleteFeeds = feedIdList.map(feedId => Number(feedId));
        const updateWallFeeds = feeds.map(wall => {
            if (wall.wallId === wallId) {
                const updatedFeedList = wall.feed.filter((item) => toDeleteFeeds.indexOf(item.id) === -1);
                wall.feed = updatedFeedList;
            }
            return wall;
        });
        setFeeds(updateWallFeeds);
    }



    return (
        <div className="home_screen_warp">
            <div className="d-flex flex-column-fluid main_content no_subheader align-items-center flex-position-center justify-content-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="screen_wrapper">
                                <div className="after_intro_screen">
                                    <div className="row">
                                        <div className="col-sm-12 text-center mb-10">
                                            <div className="d-flex align-items-center justify-content-center mb-5 mb-lg-15">
                                                <img className="img-fluid me-3" src={baseUrl(`products-icon/${getInitialRoute() == 'widget' ? 'widget': 'display'}.svg`)} height={36} width={36} alt={getInitialRoute()} />
                                                <h2 className="font-weight-boldest mb-0">{getInitialRoute() != 'widget' ?'Display':'Widget'}</h2>
                                            </div>
                                            {isFreePlan==1 && <p className='text-danger' style={{fontSize: "14px", fontWeight: "500"}}>{activePlan} {isFreePlanMsg} </p>}
                                        </div>
                                    </div>
                                    <WallFeed feedsList={feeds} deleteWall={deleteWall} deleteFeedFromWall={deleteFeedFromWall} isFreePlan={isFreePlan} show={show} setShow={setShow} loading={loading}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WallLimitExceed